import RsvpNow from '~/js/components/general/rsvp-now/RsvpNow';
import CustomTextarea from '~/js/components/form-controls/CustomTextarea';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
import '~/js/libs/jquery-ui.selectmenu.min.js';

// Variable Declaration
const reactRsvpNow = document.querySelector('#rsvp-now');
const $stateSelect = $('#js-state-select');
const $main = $('html, body');

// Open selectmenu handler
const openSelectmenuHandler = () => {
  $stateSelect.selectmenu('open');
};

// ScrollTo handler
const scrollToHandler = (event) => {
  const $this = $(event.target);
  const $elScrollTo = $('.' + $this.data('scroll-to'));
  const top = $elScrollTo.offset().top;

  event.preventDefault();

  $main.animate({
    scrollTop: top
  }, 1000);

  setTimeout(openSelectmenuHandler, 1000);
};

// Select handler
const stateSelectHandler = (event, data) => {
  if (data.item.value !== '') {
    //  console.log(data.item.value);
  }
};

// Initialization selectmenu
$stateSelect.selectmenu({
  appendTo: $stateSelect.parent(),
  change: stateSelectHandler
});

// Initialization ScrollTo
$('.js-scroll-to').on('click', scrollToHandler);

import '~/js/modules/fend';

$('#caribbean-nights-form').fend({
  rules: {
    firstName: 'lettersOnly',
    lastName: 'lettersOnly'
  }
});

const landlineInputId = 'landLineNumber';
const mobileInputId = 'mobileNumber';
const inputEvaluation = (inputElement, mirrorInputId) => {

  $(`#${mirrorInputId}`).removeAttr('required');
  $(`#${mirrorInputId}-error`).hide();
  $(`#${mirrorInputId}`).trigger('change');
};

$(`#${landlineInputId}`).on('input', (event) => {
  const inputElement = event.target;

  if (inputElement.value) {
    inputEvaluation(inputElement, mobileInputId);

  } else {

    $(`#${mobileInputId}`).attr('required', true);
  }
});

$(`#${mobileInputId}`).on('input', (event) => {
  const inputElement = event.target;

  if (inputElement.value) {
    inputEvaluation(inputElement, landlineInputId);
  } else {

    $(`#${landlineInputId}`).attr('required', true);
  }
});

// Render react component
ReactDOM.render(<RsvpNow />, reactRsvpNow);

ReactDOM.render(
  <CustomTextarea
    name="message"
    id="message"
    maxLength="4000"
    displayCharacterCount
  />,
  document.getElementById('msg-textarea')
);

ReactDOM.render(
  <CustomRecaptcha
    wrapperClassName="xs-12"
  />,
  document.getElementById('google-recaptcha')
);
